import { Allergen, IMenuItemDb } from "@dining/api-client";
import { ITag } from "@fluentui/react";
import { DefaultConstant } from "./commonConstants";

export type MenuItemImage = {
  file?: File;
  previewUrl?: string;
  imageUrl?: string;
  deleteUrl?: string;
};

export type AddItemFormInput = {
  id: string;
  name: string;
  description?: string;
  category: string;
  price: number | string;
  calories: string;
  allergens: ITag[];
  optionalAllergens: ITag[];
  image?: MenuItemImage;
};

export const addItemFormsDefault: AddItemFormInput = {
  id: "",
  name: "",
  description: "",
  category: "",
  price: 0,
  calories: "",
  allergens: [],
  optionalAllergens: [],
  image: {
    previewUrl: "",
  },
};

export const formDataToMenuItemDb = (itemData: AddItemFormInput, stationId: string): IMenuItemDb => {
  let allergenList: Allergen[] = [];
  itemData.allergens.forEach((a) => {
    allergenList.push(
      Allergen.fromJS({
        name: a.name,
        id: a.key,
        optional: itemData.optionalAllergens.includes(a),
      }),
    );
  });
  const saslessImageUrl = () => {
    const imgString = itemData.image?.imageUrl || itemData.image?.previewUrl;
    if (imgString) {
      return imgString!.substring(0, imgString!.indexOf("?sv"));
    } else {
      return "";
    }
  };

  const newItem = {
    id: itemData.id,
    itemId: itemData.id,
    name: itemData.name,
    stationId: stationId,
    description: itemData.description,
    category: itemData.category,
    amount: typeof itemData.price == "string" ? parseFloat(itemData.price.replace(/[^0-9.]/g, "")) : itemData.price, // Insures there are no monetary symbols or letters in the new item
    calories: parseInt(itemData.calories) || -1,
    canPurchaseOnline: false,
    allergens: allergenList,
    vendorId: DefaultConstant.MICROSOFT,
    quantityLimitPerCustomer: -1,
    imageUrl: saslessImageUrl(),
    timeStamp: new Date().toUTCString(),
    // set menuItem's timeToLiveInSeconds to -1, which mean it will never expire
    timeToLiveInSeconds: -1,
  } as IMenuItemDb;

  return newItem;
};

export const menuItemDbToFormData = (itemData: IMenuItemDb): AddItemFormInput => {
  const mappedItem: AddItemFormInput = {
    id: itemData.id,
    name: itemData.name,
    description: itemData.description || "",
    category: itemData.category || "",
    price: itemData?.pricing?.amount || 0.0,
    calories: itemData?.calories ? (itemData?.calories === -1 ? "" : itemData?.calories?.toString()) : "",
    allergens:
      itemData?.allergens?.map((a: Allergen) => {
        return { name: a.name, key: a.id } as ITag;
      }) || [],
    optionalAllergens:
      itemData?.allergens
        ?.filter((a: Allergen) => a.optional === true)
        .map((a: Allergen) => {
          return { name: a.name, key: a.id } as ITag;
        }) || [],
    image: { imageUrl: itemData.imageUrl, previewUrl: itemData.imageUrl } || {},
  };
  return mappedItem;
};
